import React, { useState } from "react";
import { useSidebar } from "../SidebarContext";
import Select from "react-select";


const countryOptions = [
    { value: "Afghanistan", label: "Afghanistan" },
    { value: "Albania", label: "Albania" },
    { value: "Algeria", label: "Algeria" },
    { value: "Andorra", label: "Andorra" },
    { value: "Angola", label: "Angola" },
    { value: "Antigua and Barbuda", label: "Antigua and Barbuda" },
    { value: "Argentina", label: "Argentina" },
    { value: "Armenia", label: "Armenia" },
    { value: "Australia", label: "Australia" },
    { value: "Austria", label: "Austria" },
    { value: "Azerbaijan", label: "Azerbaijan" },
    { value: "Bahamas", label: "Bahamas" },
    { value: "Bahrain", label: "Bahrain" },
    { value: "Bangladesh", label: "Bangladesh" },
    { value: "Barbados", label: "Barbados" },
    { value: "Belarus", label: "Belarus" },
    { value: "Belgium", label: "Belgium" },
    { value: "Belize", label: "Belize" },
    { value: "Benin", label: "Benin" },
    { value: "Bhutan", label: "Bhutan" },
    { value: "Bolivia", label: "Bolivia" },
    { value: "Bosnia and Herzegovina", label: "Bosnia and Herzegovina" },
    { value: "Botswana", label: "Botswana" },
    { value: "Brazil", label: "Brazil" },
    { value: "Brunei", label: "Brunei" },
    { value: "Bulgaria", label: "Bulgaria" },
    { value: "Burkina Faso", label: "Burkina Faso" },
    { value: "Burundi", label: "Burundi" },
    { value: "Cambodia", label: "Cambodia" },
    { value: "Cameroon", label: "Cameroon" },
    { value: "Canada", label: "Canada" },
    { value: "Cape Verde", label: "Cape Verde" },
    { value: "Central African Republic", label: "Central African Republic" },
    { value: "Chad", label: "Chad" },
    { value: "Chile", label: "Chile" },
    { value: "China", label: "China" },
    { value: "Colombia", label: "Colombia" },
    { value: "Comoros", label: "Comoros" },
    { value: "Congo", label: "Congo" },
    { value: "Costa Rica", label: "Costa Rica" },
    { value: "Croatia", label: "Croatia" },
    { value: "Cuba", label: "Cuba" },
    { value: "Cyprus", label: "Cyprus" },
    { value: "Czech Republic", label: "Czech Republic" },
    { value: "Denmark", label: "Denmark" },
    { value: "Djibouti", label: "Djibouti" },
    { value: "Dominica", label: "Dominica" },
    { value: "Dominican Republic", label: "Dominican Republic" },
    { value: "Ecuador", label: "Ecuador" },
    { value: "Egypt", label: "Egypt" },
    { value: "El Salvador", label: "El Salvador" },
    { value: "Equatorial Guinea", label: "Equatorial Guinea" },
    { value: "Eritrea", label: "Eritrea" },
    { value: "Estonia", label: "Estonia" },
    { value: "Eswatini", label: "Eswatini" },
    { value: "Ethiopia", label: "Ethiopia" },
    { value: "Fiji", label: "Fiji" },
    { value: "Finland", label: "Finland" },
    { value: "France", label: "France" },
    { value: "Gabon", label: "Gabon" },
    { value: "Gambia", label: "Gambia" },
    { value: "Georgia", label: "Georgia" },
    { value: "Germany", label: "Germany" },
    { value: "Ghana", label: "Ghana" },
    { value: "Greece", label: "Greece" },
    { value: "Grenada", label: "Grenada" },
    { value: "Guatemala", label: "Guatemala" },
    { value: "Guinea", label: "Guinea" },
    { value: "Guinea-Bissau", label: "Guinea-Bissau" },
    { value: "Guyana", label: "Guyana" },
    { value: "Haiti", label: "Haiti" },
    { value: "Honduras", label: "Honduras" },
    { value: "Hungary", label: "Hungary" },
    { value: "Iceland", label: "Iceland" },
    { value: "India", label: "India" },
    { value: "Indonesia", label: "Indonesia" },
    { value: "Iran", label: "Iran" },
    { value: "Iraq", label: "Iraq" },
    { value: "Ireland", label: "Ireland" },
    { value: "Israel", label: "Israel" },
    { value: "Italy", label: "Italy" },
    { value: "Jamaica", label: "Jamaica" },
    { value: "Japan", label: "Japan" },
    { value: "Jordan", label: "Jordan" },
    { value: "Kazakhstan", label: "Kazakhstan" },
    { value: "Kenya", label: "Kenya" },
    { value: "Kiribati", label: "Kiribati" },
    { value: "Kuwait", label: "Kuwait" },
    { value: "Kyrgyzstan", label: "Kyrgyzstan" },
    { value: "Laos", label: "Laos" },
    { value: "Latvia", label: "Latvia" },
    { value: "Lebanon", label: "Lebanon" },
    { value: "Lesotho", label: "Lesotho" },
    { value: "Liberia", label: "Liberia" },
    { value: "Libya", label: "Libya" },
    { value: "Liechtenstein", label: "Liechtenstein" },
    { value: "Lithuania", label: "Lithuania" },
    { value: "Luxembourg", label: "Luxembourg" },
    { value: "Madagascar", label: "Madagascar" },
    { value: "Malawi", label: "Malawi" },
    { value: "Malaysia", label: "Malaysia" },
    { value: "Maldives", label: "Maldives" },
    { value: "Mali", label: "Mali" },
    { value: "Malta", label: "Malta" },
    { value: "Marshall Islands", label: "Marshall Islands" },
    { value: "Mauritania", label: "Mauritania" },
    { value: "Mauritius", label: "Mauritius" },
    { value: "Mexico", label: "Mexico" },
    { value: "Micronesia", label: "Micronesia" },
    { value: "Moldova", label: "Moldova" },
    { value: "Monaco", label: "Monaco" },
    { value: "Mongolia", label: "Mongolia" },
    { value: "Montenegro", label: "Montenegro" },
    { value: "Morocco", label: "Morocco" },
    { value: "Mozambique", label: "Mozambique" },
    { value: "Myanmar", label: "Myanmar" },
    { value: "Namibia", label: "Namibia" },
    { value: "Nauru", label: "Nauru" },
    { value: "Nepal", label: "Nepal" },
    { value: "Netherlands", label: "Netherlands" },
    { value: "New Zealand", label: "New Zealand" },
    { value: "Nicaragua", label: "Nicaragua" },
    { value: "Niger", label: "Niger" },
    { value: "Nigeria", label: "Nigeria" },
    { value: "North Korea", label: "North Korea" },
    { value: "North Macedonia", label: "North Macedonia" },
    { value: "Norway", label: "Norway" },
    { value: "Oman", label: "Oman" },
    { value: "Pakistan", label: "Pakistan" },
    { value: "Palau", label: "Palau" },
    { value: "Palestine", label: "Palestine" },
    { value: "Panama", label: "Panama" },
    { value: "Papua New Guinea", label: "Papua New Guinea" },
    { value: "Paraguay", label: "Paraguay" },
    { value: "Peru", label: "Peru" },
    { value: "Philippines", label: "Philippines" },
    { value: "Poland", label: "Poland" },
    { value: "Portugal", label: "Portugal" },
    { value: "Qatar", label: "Qatar" },
    { value: "Romania", label: "Romania" },
    { value: "Russia", label: "Russia" },
    { value: "Rwanda", label: "Rwanda" },
    { value: "Saint Kitts and Nevis", label: "Saint Kitts and Nevis" },
    { value: "Saint Lucia", label: "Saint Lucia" },
    { value: "Saint Vincent and the Grenadines", label: "Saint Vincent and the Grenadines" },
    { value: "Samoa", label: "Samoa" },
    { value: "San Marino", label: "San Marino" },
    { value: "Sao Tome and Principe", label: "Sao Tome and Principe" },
    { value: "Saudi Arabia", label: "Saudi Arabia" },
    { value: "Senegal", label: "Senegal" },
    { value: "Serbia", label: "Serbia" },
    { value: "Seychelles", label: "Seychelles" },
    { value: "Sierra Leone", label: "Sierra Leone" },
    { value: "Singapore", label: "Singapore" },
    { value: "Slovakia", label: "Slovakia" },
    { value: "Slovenia", label: "Slovenia" },
    { value: "Solomon Islands", label: "Solomon Islands" },
    { value: "Somalia", label: "Somalia" },
    { value: "South Africa", label: "South Africa" },
    { value: "South Korea", label: "South Korea" },
    { value: "South Sudan", label: "South Sudan" },
    { value: "Spain", label: "Spain" },
    { value: "Sri Lanka", label: "Sri Lanka" },
    { value: "Sudan", label: "Sudan" },
    { value: "Suriname", label: "Suriname" },
    { value: "Sweden", label: "Sweden" },
    { value: "Switzerland", label: "Switzerland" },
    { value: "Syria", label: "Syria" },
    { value: "Taiwan", label: "Taiwan" },
    { value: "Tajikistan", label: "Tajikistan" },
    { value: "Tanzania", label: "Tanzania" },
    { value: "Thailand", label: "Thailand" },
    { value: "Togo", label: "Togo" },
    { value: "Tonga", label: "Tonga" },
    { value: "Trinidad and Tobago", label: "Trinidad and Tobago" },
    { value: "Tunisia", label: "Tunisia" },
    { value: "Turkey", label: "Turkey" },
    { value: "Turkmenistan", label: "Turkmenistan" },
    { value: "Tuvalu", label: "Tuvalu" },
    { value: "Uganda", label: "Uganda" },
    { value: "Ukraine", label: "Ukraine" },
    { value: "United Arab Emirates", label: "United Arab Emirates" },
    { value: "United Kingdom", label: "United Kingdom" },
    { value: "United States", label: "United States" },
    { value: "Uruguay", label: "Uruguay" },
    { value: "Uzbekistan", label: "Uzbekistan" },
    { value: "Vanuatu", label: "Vanuatu" },
    { value: "Vatican City", label: "Vatican City" },
    { value: "Venezuela", label: "Venezuela" },
    { value: "Vietnam", label: "Vietnam" },
    { value: "Yemen", label: "Yemen" },
    { value: "Zambia", label: "Zambia" },
    { value: "Zimbabwe", label: "Zimbabwe" },
];



export default function UserForm() {
    const [formData, setFormData] = useState({});
    
    const [showPanels, setShowPanels] = useState({
        domain_yes: false,
        domain_no: false,
        hosting_yes: false,
        hosting_no: false,
        merchant_yes: false,
        compliance_yes: false,
        training_mode_wrap: false,
        hoisting_owned: false,
    });

    const url = process.env.REACT_APP_LINK;

    const handleChange = (e) => {
        const { name, value, type, checked, files } = e.target;

        if (type === "checkbox") {
            setFormData((prev) => ({
                ...prev,
                [name]: prev[name]
                    ? checked
                        ? [...prev[name], value]
                        : prev[name].filter((v) => v !== value)
                    : [value],
            }));
        } else if (type === "file") {
            setFormData((prev) => ({ ...prev, [name]: files }));
        } else {
            setFormData((prev) => ({ ...prev, [name]: value }));
        }

        // Conditional panels
        const panels = {
            domain_owned: { domain_yes: value === "yes", domain_no: value === "no" },
            has_hosting: { hosting_yes: value === "yes", hosting_no: value === "no" },
            has_merchant: { merchant_yes: value === "yes" },
            has_compliance: { compliance_yes: value === "yes" },
            need_training: { training_mode_wrap: value === "yes" },
        };

        if (panels[name]) {
            setShowPanels((prev) => ({ ...prev, ...panels[name] }));
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const submission = new FormData();

        Object.keys(formData).forEach((key) => {
            if (formData[key] instanceof FileList) {
                Array.from(formData[key]).forEach((file) =>
                    submission.append(key, file)
                );
            } else if (Array.isArray(formData[key])) {
                formData[key].forEach((v) => submission.append(key, v));
            } else {
                submission.append(key, formData[key]);
            }
        });

        try {
            const res = await fetch(`${url}/api/onboarding/submit`, {
                method: "POST",
                body: submission,
            });
            const result = await res.json();
            alert(result.message || "Form submitted successfully!");
        } catch (err) {
            console.error("Error submitting form:", err);
            alert("Submission failed. Please try again.");
        }
    };

    return (
        <>
            {/* HEADER */}
            <div className="flex items-center justify-between mb-8">
                {/* <h1 className="text-3xl font-extrabold bg-gradient-to-r from-blue-700 to-indigo-500 bg-clip-text text-transparent">
          🌐 Website Onboarding Form
        </h1> */}
            </div>

            <form
                onSubmit={handleSubmit}
                className="max-w-5xl mx-auto bg-white/80 backdrop-blur-md shadow-2xl border border-gray-100 rounded-2xl p-8 space-y-10"
            >
                {/* SECTION 1 */}
                <section className="space-y-4">
                    <h2 className="text-2xl font-semibold text-gray-800 border-b pb-2">
                        1) Company Information
                    </h2>
                    <div className="grid md:grid-cols-2 gap-6">
                        {[
                            { id: "business_name", label: "Business Name", required: true },
                            { id: "registered_name", label: "Registered Company Name" },
                            {
                                id: "industry",
                                label: "Business Category / Industry",
                                required: true,
                            },
                            { id: "gst", label: "GST Number (if applicable)" },
                            { id: "contact_person", label: "Contact Person", required: true },
                            { id: "phone", label: "Phone", required: true },
                            { id: "email", label: "Email", required: true },
                        ].map((f) => (
                            <div key={f.id} className="flex flex-col">
                                <label className="text-sm font-medium text-gray-600 mb-1">
                                    {f.label} {f.required && <span className="text-red-500">*</span>}
                                </label>
                                <input
                                    id={f.id}
                                    name={f.id}
                                    required={f.required}
                                    type="text"
                                    onChange={handleChange}
                                    className="border border-gray-300 rounded-lg p-2.5 shadow-sm focus:ring-2 focus:ring-blue-400 focus:outline-none transition"
                                />
                            </div>
                        ))}
                        <div className="col-span-2">
                            <label className="text-sm font-medium text-gray-600 mb-1">
                                Business Address
                            </label>
                            <textarea
                                id="address"
                                name="address"
                                onChange={handleChange}
                                rows={3}
                                className="border border-gray-300 rounded-lg p-2.5 w-full shadow-sm focus:ring-2 focus:ring-blue-400 focus:outline-none transition"
                            ></textarea>
                        </div>
                        <div>
                            <label className="block text-sm font-medium ">
                                About Us/Company Profile
                            </label>
                            <textarea
                                // placeholder="Category > Subcategory (one per line)"
                                rows="4"
                                className="w-full mt-1  border  rounded-lg px-3 py-2 focus:ring-2 focus:ring-indigo-600 focus:outline-none"
                            ></textarea>
                        </div>
                    </div>
                </section>

                {/* SECTION 2 */}
                <section className="space-y-4">
                    <h2 className="text-2xl font-semibold text-gray-800 border-b pb-2">
                        2) Domain & Website Details
                    </h2>

                    {/* DOMAIN */}
                    <div className="space-y-3">
                        <p className="font-medium text-gray-700">
                            Do you already own a domain?
                        </p>
                        <div className="flex gap-6">
                            {["yes", "no"].map((v) => (
                                <label
                                    key={v}
                                    className="flex items-center gap-2 text-gray-600 cursor-pointer hover:text-blue-600 transition"
                                >
                                    <input
                                        type="radio"
                                        name="domain_owned"
                                        value={v}
                                        onChange={handleChange}
                                        className="accent-blue-500"
                                    />
                                    {v.toUpperCase()}
                                </label>
                            ))}
                        </div>

                        {showPanels.domain_yes && (
                            <div className="bg-blue-50/60 border-l-4 border-blue-400 rounded-lg p-4 space-y-3">
                                <input
                                    name="domain_name"
                                    onChange={handleChange}
                                    placeholder="Domain Name"
                                    className="w-full border p-2 rounded-md"
                                />
                                <input
                                    name="registrar"
                                    onChange={handleChange}
                                    placeholder="Registrar"
                                    className="w-full border p-2 rounded-md"
                                />
                                <textarea
                                    name="domain_credentials"
                                    onChange={handleChange}
                                    placeholder="Registrar Access Details"
                                    className="w-full border p-2 rounded-md"
                                />
                            </div>
                        )}

                        {showPanels.domain_no && (
                            <div className="bg-gray-50 border border-dashed rounded-lg p-4 space-y-3">
                                <select
                                    name="domain_purchase"
                                    onChange={handleChange}
                                    className="w-full border p-2 rounded-md"
                                >
                                    <option value="undecided">Undecided</option>
                                    <option value="yes">Yes</option>
                                    <option value="no">No</option>
                                </select>
                                <input
                                    name="domain_options"
                                    onChange={handleChange}
                                    placeholder="Preferred domain options (comma separated)"
                                    className="w-full border p-2 rounded-md"
                                />
                            </div>
                        )}
                    </div>

                    {/* HOSTING */}
                    <div className="space-y-3">
                        <p className="font-medium text-gray-700">
                            Do you already have hosting?
                        </p>
                        <div className="flex gap-6">
                            {["yes", "no"].map((v) => (
                                <label
                                    key={v}
                                    className="flex items-center gap-2 text-gray-600 cursor-pointer hover:text-blue-600 transition"
                                >
                                    <input
                                        type="radio"
                                        name="has_hosting"
                                        value={v}
                                        onChange={handleChange}
                                        className="accent-blue-500"
                                    />
                                    {v.toUpperCase()}
                                </label>
                            ))}
                        </div>
                        {showPanels.hosting_yes && (
                            <div className="bg-blue-50/60 border-l-4 border-blue-400 rounded-lg p-4 space-y-3">
                                <input
                                    name="hosting_provider"
                                    onChange={handleChange}
                                    placeholder="Hosting Provider"
                                    className="w-full border p-2 rounded-md"
                                />
                                <input
                                    name="hosting_plan"
                                    onChange={handleChange}
                                    placeholder="Plan / Resources"
                                    className="w-full border p-2 rounded-md"
                                />
                                <textarea
                                    name="hosting_credentials"
                                    onChange={handleChange}
                                    placeholder="Access Details / Control Panel"
                                    className="w-full border p-2 rounded-md"
                                />
                            </div>
                        )}
                        {showPanels.hosting_no && (
                            <div className="bg-gray-50 border border-dashed rounded-lg p-4 space-y-3">
                                <select
                                    name="hosting_purchase"
                                    onChange={handleChange}
                                    className="w-full border p-2 rounded-md"
                                >
                                    <option value="undecided">Undecided</option>
                                    <option value="yes">Yes</option>
                                    <option value="no">No</option>
                                </select>
                                <input
                                    name="hosting_options"
                                    onChange={handleChange}
                                    placeholder="Preferred hosting options (e.g., provider, storage)"
                                    className="w-full border p-2 rounded-md"
                                />
                            </div>
                        )}
                    </div>

                    {/* BRANDING */}
                    <div className="space-y-3">
                        <p className="font-medium text-gray-700">Logo & Branding Materials</p>
                        <div className="bg-gray-50 border border-dashed border-gray-300 rounded-lg p-4">
                            <input
                                type="file"
                                name="branding_files"
                                multiple
                                onChange={handleChange}
                                className="w-full text-sm text-gray-600 file:mr-4 file:py-2 file:px-4 file:rounded-md file:border-0 file:bg-blue-600 file:text-white hover:file:bg-blue-700"
                            />
                            <p className="text-xs text-gray-500 mt-1">
                                You can upload multiple files (images, ZIP).
                            </p>
                        </div>
                    </div>

                    {/* COLORS & STYLE */}
                    <div className="space-y-3">
                        <p className="font-medium text-gray-700">Preferred Colors / Style</p>
                        <input
                            type="text"
                            name="color_style"
                            onChange={handleChange}
                            placeholder="e.g. Modern, minimal, #ffc100, #007bff"
                            className="w-full border p-2 rounded-md"
                        />
                    </div>

                    {/* THEME */}
                    <div className="space-y-3">
                        <p className="font-medium text-gray-700">
                            Preferred Website Theme / Layout (URL or notes)
                        </p>
                        <input
                            type="text"
                            name="theme_url"
                            onChange={handleChange}
                            placeholder="https://example.com/reference"
                            className="w-full border p-2 rounded-md"
                        />
                    </div>
                </section>


                {/* step 3 ecommerce */}
                <section className="space-y-6 ">
                    <h2 className="text-2xl font-semibold border-b border-gray-700 pb-2">
                        3) E-Commerce Setup
                    </h2>

                    {/* Type of Products */}
                    <div className="space-y-3">
                        <label className="block text-sm font-medium ">
                            Type of Products
                        </label>
                        <div className="flex flex-wrap gap-3">
                            {["Physical", "Digital", "Services", "Subscription"].map((type) => (
                                <label
                                    key={type}
                                    className="flex items-center gap-2 px-4 py-2 border border-gray-700 rounded-lg cursor-pointer  "
                                >
                                    <input
                                        type="checkbox"
                                        value={type.toLowerCase()}
                                        className="accent-indigo-600 w-4 h-4"
                                    />
                                    <span>{type}</span>
                                </label>
                            ))}
                        </div>
                    </div>

                    {/* Approx Products + Product Upload + Currency */}
                    <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
                        <div>
                            <label className="block text-sm font-medium ">
                                Approx. Number of Products
                            </label>
                            <input
                                type="number"
                                placeholder="e.g., 250"
                                className="w-full mt-1  border  rounded-lg px-3 py-2 focus:ring-2 focus:ring-indigo-600 focus:outline-none"
                            />
                        </div>

                        <div>
                            <label className="block text-sm font-medium  mb-1">
                                Need product upload support?
                            </label>
                            <div className="flex items-center gap-4">
                                <label className="flex items-center gap-2 cursor-pointer">
                                    <input
                                        type="radio"
                                        name="uploadSupport"
                                        value="yes"
                                        className="accent-indigo-600"
                                    />
                                    <span>Yes</span>
                                </label>
                                <label className="flex items-center gap-2 cursor-pointer">
                                    <input
                                        type="radio"
                                        name="uploadSupport"
                                        value="no"
                                        className="accent-indigo-600"
                                    />
                                    <span>No</span>
                                </label>
                            </div>
                        </div>

                        <div>
                            <label className="block text-sm font-medium ">
                                Currency
                            </label>
                            <select className="w-full mt-1  border  rounded-lg px-3 py-2 focus:ring-2 focus:ring-indigo-600 focus:outline-none">
                                <option>INR</option>
                                <option>USD</option>
                                <option>EUR</option>
                            </select>
                        </div>
                    </div>

                    {/* Country */}
                    <div>
                        <label className="block text-sm font-medium ">
                            Country of Operation
                        </label>
                        <Select
                            options={countryOptions}
                            placeholder="Select or search country"
                            name="country"
                            onChange={(selected) =>
                                handleChange({ target: { name: "country", value: selected.value } })
                            }
                        />
                    </div>

                    {/* Categories & Subcategories */}


                    {/* Pricing Structure + Notes */}

                </section>

                <section className="space-y-6 ">
                    <h2 className="text-2xl font-semibold border-b border-gray-700 pb-2">
                        4)  Payment & Shipping
                    </h2>

                    <div className="space-y-3">
                        <label className="block text-sm font-medium ">
                            Preferred Payment Gateways
                        </label>
                        <div className="flex flex-wrap gap-3">
                            {["Razorpay"].map((type) => (
                                <label
                                    key={type}
                                    className="flex items-center gap-2 px-4 py-2 border rounded-lg cursor-pointer  "
                                >
                                    <input
                                        type="checkbox"
                                        value={type.toLowerCase()}
                                        className="accent-indigo-600 w-4 h-4"
                                    />
                                    <span>{type}</span>
                                </label>
                            ))}
                        </div>
                    </div>

                    <div className="space-y-3">
                        <p className="font-medium text-gray-700">
                            Do you already have merchant accounts?
                        </p>
                        <div className="flex gap-6">
                            {["yes", "no"].map((v) => (
                                <label
                                    key={v}
                                    className="flex items-center gap-2 text-gray-600 cursor-pointer hover:text-blue-600 transition"
                                >
                                    <input
                                        type="radio"
                                        name="has_merchant"
                                        value={v}
                                        onChange={handleChange}
                                        className="accent-blue-500"
                                    />
                                    {v.toUpperCase()}
                                </label>
                            ))}

                        </div>
                        {showPanels.merchant_yes && (
                            <div className="col-span-2">
                                <label className="text-sm font-medium text-gray-600 mb-1">
                                    Merchant Details
                                </label>
                                <textarea
                                    id="address"
                                    name="address"
                                    onChange={handleChange}
                                    rows={3}
                                    placeholder="MID, live test keys (share securely), status, contacts"
                                    className="border border-gray-300 rounded-lg p-2.5 w-full shadow-sm focus:ring-2 focus:ring-blue-400 focus:outline-none transition"
                                ></textarea>
                            </div>
                        )}

                    </div>
                    <div className="space-y-3">
                        <label className="block text-sm font-medium ">
                            Delivery Locations
                        </label>
                        <div className="flex flex-wrap gap-3">
                            {["Local", "National", "International"].map((type) => (
                                <label
                                    key={type}
                                    className="flex items-center gap-2 px-4 py-2 border rounded-lg cursor-pointer  "
                                >
                                    <input
                                        type="checkbox"
                                        value={type.toLowerCase()}
                                        className="accent-indigo-600 w-4 h-4"
                                    />
                                    <span>{type}</span>
                                </label>
                            ))}
                        </div>
                    </div>
                </section>




                <section className="space-y-4">
                    <h2 className="text-2xl font-semibold text-gray-800 border-b pb-2">
                        5) Support & Training
                    </h2>

                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                        {/* Training Required */}
                        <div className="space-y-3">
                            <p className="font-medium text-gray-700">Do you want staff training?</p>
                            <div className="flex gap-6">
                                {["yes", "no"].map((v) => (
                                    <label
                                        key={v}
                                        className="flex items-center gap-2 text-gray-600 cursor-pointer hover:text-blue-600 transition"
                                    >
                                        <input
                                            type="radio"
                                            name="has_hosting"
                                            value={v}
                                            onChange={handleChange}
                                            className="accent-blue-500"
                                        />
                                        {v.toUpperCase()}
                                    </label>
                                ))}
                            </div>
                        </div>

                        {/* Preferred Training Mode */}
                        {formData.has_hosting === "yes" && (
                            <div className="space-y-3">
                                <p className="font-medium text-gray-700">Preferred Training Mode</p>
                                <select
                                    className="w-full px-4 py-2 border border-gray-300 rounded-lg shadow-sm focus:outline-none 
            focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-gray-700 bg-white transition"
                                >
                                    <option value="">Select</option>
                                    <option value="Online">Online</option>
                                </select>
                            </div>
                        )}
                        <div>
                            <label className="block text-sm font-medium ">
                                Name (Support team)
                            </label>
                            <input
                                type="text"
                                placeholder="Enter support person Name"
                                className="w-full mt-1  border  rounded-lg px-3 py-2 focus:ring-2 focus:ring-indigo-600 focus:outline-none"
                            />
                        </div>
                        <div>
                            <label className="block text-sm font-medium ">
                                Support Email
                            </label>
                            <input
                                type="email"
                                placeholder="Enter Email e.g. example@gmail.com"
                                className="w-full mt-1  border  rounded-lg px-3 py-2 focus:ring-2 focus:ring-indigo-600 focus:outline-none"
                            />
                        </div>
                        <div>
                            <label className="block text-sm font-medium ">
                                Support Phone
                            </label>
                            <input
                                type="text"
                                placeholder="Enter Phone number eg. +91xxxxxxxxx"
                                className="w-full mt-1  border  rounded-lg px-3 py-2 focus:ring-2 focus:ring-indigo-600 focus:outline-none"
                            />
                        </div>
                    </div>

                </section>
                <section className="space-y-4">
                    <h2 className="text-2xl font-semibold text-gray-800 border-b pb-2">
                        6) Final Notes
                    </h2>

                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                        {/* Training Required */}

                        {/* Preferred Training Mode */}

                        <div>
                            <label className="block text-sm font-medium ">
                                Launch Date / Deadline
                            </label>
                            <input
                                type="date"
                                // placeholder="Enter Name"
                                className="w-full mt-1  border  rounded-lg px-3 py-2 focus:ring-2 focus:ring-indigo-600 focus:outline-none"
                            />
                        </div>
                        <div>
                            <label className="block text-sm font-medium ">
                                Additional Comments / Special Requests
                            </label>
                            <textarea
                                // placeholder="Category > Subcategory (one per line)"
                                rows="4"
                                className="w-full mt-1  border  rounded-lg px-3 py-2 focus:ring-2 focus:ring-indigo-600 focus:outline-none"
                            ></textarea>
                        </div>
                    </div>

                </section>

                {/* BUTTONS */}
                <div className="flex justify-end gap-4 pt-6 border-t">
                    <button
                        type="reset"
                        className="px-5 py-2.5 rounded-md border border-gray-300 bg-gray-100 hover:bg-gray-200 transition"
                    >
                        Reset
                    </button>
                    <button
                        type="submit"
                        className="px-6 py-2.5 rounded-md bg-gradient-to-r from-blue-600 to-indigo-600 text-white font-semibold shadow-md hover:shadow-lg transform hover:-translate-y-0.5 transition"
                    >
                        🚀 Submit Onboarding
                    </button>
                </div>
            </form>
        </>
    );
}
